module.exports = __webpack_public_path__ + "img/border_gemstone.36cfa55e.svg";